// @ts-check

import React, { useEffect } from "react";
import { Page, BlockStack, Layout } from "@shopify/polaris";
import { usePostHog } from "posthog-js/react";

import { Dashboard } from "components/dashboard/Dashboard/Dashboard";
import { ProfitTrackerFeatureBanner } from "components/ProfitTrackerFeatureBanner/ProfitTrackerFeatureBanner";
import { SyncingBanner } from "components/SyncingBanner/SyncingBanner";

export default function DashboardPage() {
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture("$pageview");
  }, []);

  return (
    <Page
      title="Dashboard"
      subtitle="Welcome to Origin"
      fullWidth
    >
      <Layout>
        <Layout.Section>
          <BlockStack gap="400">
            <BlockStack gap="0">
              <SyncingBanner />
            </BlockStack>

            <Dashboard />
          </BlockStack>
        </Layout.Section>
      </Layout>
    </Page>
  );
};
